import { Grid, type GridProps } from '@mui/material';
import type { FC } from 'react';

export type GridContainerProps = Omit<GridProps, 'container' | 'item'>;

export const GridContainer: FC<GridContainerProps> = ({ spacing = 3, ...rest }) => {
  return <Grid container spacing={spacing} {...rest} />;
};
